export const PERCENTAGE_OPTIONS: [number, number, number, number] = [25, 50, 75, 100];
export const DEFAULT_AMOUNT_OPTION: number = 1;
export const TRADABLE_PRECISION: number = 8;
export const INTERVAL_DAILY: number = 1;
export const INTERVAL_WEEKLY: number = 7;
